module.exports = __webpack_public_path__ + "static/media/lockResized.c2f236cc.jpeg";